
export type HubspotTrackingState = {
  widgetLoaded: boolean
  identified: boolean
  busy: boolean
}

export const initialHubspotTrackingState: HubspotTrackingState = {
  widgetLoaded: false,
  identified: false,
  busy: false
}

export const hubspotTrackingStateUpdaters = {
  resetIdentity: (s: HubspotTrackingState): HubspotTrackingState =>
    ({ ...s, identified: false, busy: false })  
}